import Cookies from 'js-cookie';

import SessionWrapper from './sessionWrapper';
import UserTokenFactory from './userTokenFactory';
import SESSION_STORAGE_KEYS from './../../config/sessionStorageKeys';


const STORAGE_KEY = 'ODM_SESSION';

let session = new SessionWrapper('localStorage', STORAGE_KEY);

function setAuthCookie(value) {
    Cookies.set(SESSION_STORAGE_KEYS.AUTH_HEADER, value);
}


export default {
    getAuthHeader() {
        return session.getItem(SESSION_STORAGE_KEYS.AUTH_HEADER);
    },
    
    setAuthHeader(value) {
        setAuthCookie(value);
        return session.setItem(SESSION_STORAGE_KEYS.AUTH_HEADER, value);
    },

    setAuthCookieFromHeader() {
        setAuthCookie(session.getItem(SESSION_STORAGE_KEYS.AUTH_HEADER));
    },
    
    getUserToken() {
        return UserTokenFactory.create(session.getItem(SESSION_STORAGE_KEYS.TOKEN));
    },
    
    setRawToken(value) {
        return session.setItem(SESSION_STORAGE_KEYS.TOKEN, value);
    },
    
    clear() {
        Cookies.remove(SESSION_STORAGE_KEYS.AUTH_HEADER);
        session.clear();
    },
    

    // Just for testing!
    __setSession(s) {
        session = s;
    },
    __getAuthCookie(){
        return Cookies.get(SESSION_STORAGE_KEYS.AUTH_HEADER);
    }
};